<template>
	<div class="certificate">
		<img class="certificate-banner" src="https://bernouly.oss-cn-beijing.aliyuncs.com/1%2BX/banner.png" alt="">
		<!-- 师资培训 布局样式 -->

		<div class="w-video">
			<div style="height: 60px;"></div>
			<div class="video-title">
				<span style="font-size: 30px;color: #333333;font-weight: bold;">课程视频</span><br />
				<span style="font-size: 16px;color: #999999;">COURSE VIDEO</span>
			</div>
			<div class="video">
				<div class="fanhui" @click="fanhui()">
					返回上一页
				</div>
				<!-- 课程视频-主播放窗口 -->
				<div style="position: relative;z-index: 1;">
					<video id="movie" class="video-main" :src="videoList[playIndex].video" controls="controls"
					 controlslist="nodownload"></video>
					<div class="video-main-title">{{videoList[playIndex].title}}</div>
					<div class="video-show" @click="videoPlay()">
						<img v-if="videoFlag" class="bofang1" src="../../assets/1+X/bofang1.png" alt="">
					</div>
					<!-- 课程视频-右侧列表 -->
					<div v-if="jiantouFlag" @click="suojin()" class="jiantou"><img src="../../assets/right32.png" alt=""></div>
					<div v-else @click="suojin()" class="jiantou1"><img src="../../assets/left32.png" alt=""></div>
					<div v-show="jiantouFlag" class="video-mini" @mousewheel="wheel()">
						<ul>
							<li v-for="(item,index) in videoList" v-if="index >= videoIndex" :key="index" @click="change(index)">
								<img :src="item.img" />
								<img class="video-mini-img" src="../../assets/1+X/bofang2.png">
								<div :class="index==playIndex ? 'video-mini-title1' : 'video-mini-title'">{{item.title}}</div>
							</li>
						</ul>
						<div class="arrow-up" @click="arrowUp">
							<span class="revolve"><</span>
						</div>
						<div class="arrow-down" @click="arrowDown">
							<span class="revolve">></span>
						</div>
					</div>
				</div>

			</div>
		</div>
		<div class="train">

			<div class="course-title">
				<span style="font-size: 30px;color: #333333;font-weight: bold;">课程内容</span><br />
				<span style="font-size: 16px;color: #999999;">COURSE CONTENT</span>
			</div>
			<!-- 师资培训-课程内容-列表 -->
			<div class="down-list">
				<div v-for="(item,index) in titleList" :key="index" class="down-item">
					<div class="down-item-left"><img src="../../assets/1+X/ppt.png" />{{item.name}}</div>
					<div v-if="item.attachment!=''" class="down-item-right"><a :href="item.attachment">
							<p>Download</p>
						</a></div>
					<div v-else class="down-item-right"><a>
							<p>Download</p>
						</a></div>
				</div>
			</div>
			<!-- 师资培训-课程内容-分页 -->
			<div class="title-page" style="padding: 0;margin: 60px 0 50px 0;">
				<div class="flex">
					<div class="box active">1</div>
				</div>
				<div class="box title-page-active" style="width: 150px;">下一页</div>
			</div>
		</div>
	</div>

</template>

<script>
	//禁止此页的右键事件
	document.oncontextmenu = function() {
		return false;
	};

	export default {
		components: {},
		data() {
			return {
				mouseFlag:false,
				jiantouFlag: true,
				index: 0,
				videoIndex: 0, //video-mini-list开始下标
				playIndex: 0, //video-main所显示播放列表中的视频内容
				videoFlag: true, //控制ideo-main的播放图标 true显示 false不显示
				/**
				 * img:视频列表显示的图片
				 * video:主播放窗口的视频链接
				 * title:视频列表及主播放窗口下显示的文字
				 * 
				 * 后台没有相关模块  更新需要修改页面数据
				 */
				videoList: [{
					img: 'http://bernouly.oss-cn-beijing.aliyuncs.com/1%2BX/tupian1.png',
					video: 'https://bernouly.oss-cn-beijing.aliyuncs.com/train/%E5%9E%83%E5%9C%BE%E7%84%9A%E7%83%A7%E7%AC%AC%E4%B8%80%E6%9C%9F/%E8%A7%86%E9%A2%91/1.%E5%9E%83%E5%9C%BE%E7%84%9A%E7%83%A7%E5%8F%91%E7%94%B5%E6%9C%BA%E7%BB%84%E9%94%85%E7%82%89%E8%AE%BE%E5%A4%87%E5%8F%8A%E8%BF%90%E8%A1%8C.mp4',
					title: '1.垃圾焚烧发电机组锅炉设备及运行'
				}, {
					img: 'http://bernouly.oss-cn-beijing.aliyuncs.com/1%2BX/tupian2.png',
					video: 'https://bernouly.oss-cn-beijing.aliyuncs.com/train/%E5%9E%83%E5%9C%BE%E7%84%9A%E7%83%A7%E7%AC%AC%E4%B8%80%E6%9C%9F/%E8%A7%86%E9%A2%91/2.%E5%9E%83%E5%9C%BE%E7%84%9A%E7%83%A7%E5%8F%91%E7%94%B5%E6%9C%BA%E7%BB%84%E9%94%85%E7%82%89%E5%90%AF%E5%81%9C.mp4',
					title: '2.垃圾焚烧发电机组锅炉启停'
				}, {
					img: 'http://bernouly.oss-cn-beijing.aliyuncs.com/1%2BX/tupian3.png',
					video: 'https://bernouly.oss-cn-beijing.aliyuncs.com/train/%E5%9E%83%E5%9C%BE%E7%84%9A%E7%83%A7%E7%AC%AC%E4%B8%80%E6%9C%9F/%E8%A7%86%E9%A2%91/3.%E5%9E%83%E5%9C%BE%E7%84%9A%E7%83%A7%E5%8F%91%E7%94%B5%E6%9C%BA%E7%BB%84%E9%94%85%E7%82%89%E8%BF%90%E8%A1%8C%E8%B0%83%E6%95%B4.mp4',
					title: '3.垃圾焚烧发电机组锅炉运行调整'
				}, {
					img: 'http://bernouly.oss-cn-beijing.aliyuncs.com/1%2BX/tupian4.png',
					video: 'https://bernouly.oss-cn-beijing.aliyuncs.com/train/%E5%9E%83%E5%9C%BE%E7%84%9A%E7%83%A7%E7%AC%AC%E4%B8%80%E6%9C%9F/%E8%A7%86%E9%A2%91/4.%E5%9E%83%E5%9C%BE%E7%84%9A%E7%83%A7%E5%8F%91%E7%94%B5%E6%9C%BA%E7%BB%84%E6%B1%BD%E8%BD%AE%E6%9C%BA%E8%AE%BE%E5%A4%87%E5%8F%8A%E7%B3%BB%E7%BB%9F.mp4',
					title: '4.垃圾焚烧发电机组汽轮机设备及系统'
				}, {
					img: 'http://bernouly.oss-cn-beijing.aliyuncs.com/1%2BX/tupian1.png',
					video: 'https://bernouly.oss-cn-beijing.aliyuncs.com/train/%E5%9E%83%E5%9C%BE%E7%84%9A%E7%83%A7%E7%AC%AC%E4%B8%80%E6%9C%9F/%E8%A7%86%E9%A2%91/5.%E5%9E%83%E5%9C%BE%E7%84%9A%E7%83%A7%E5%8F%91%E7%94%B5%E6%9C%BA%E7%BB%84%E6%B1%BD%E8%BD%AE%E6%9C%BA%E8%BF%90%E8%A1%8C.mp4',
					title: '5.垃圾焚烧发电机组汽轮机运行'
				}, {
					img: 'http://bernouly.oss-cn-beijing.aliyuncs.com/1%2BX/tupian2.png',
					video: 'https://bernouly.oss-cn-beijing.aliyuncs.com/train/%E5%9E%83%E5%9C%BE%E7%84%9A%E7%83%A7%E7%AC%AC%E4%B8%80%E6%9C%9F/%E8%A7%86%E9%A2%91/6.%E5%9E%83%E5%9C%BE%E7%84%9A%E7%83%A7%E5%8F%91%E7%94%B5%E6%9C%BA%E7%BB%84%E7%94%B5%E6%B0%94%E7%B3%BB%E7%BB%9F%E7%9A%84%E4%B8%BB%E8%A6%81%E8%AE%BE%E5%A4%87%E5%92%8C%E8%BF%90%E8%A1%8C%E6%96%B9%E5%BC%8F.mp4',
					title: '6.垃圾焚烧发电机组电气系统的主要设备和运行方式'
				}],
				titleList: [{
						"name": "1.垃圾焚烧发电机组锅炉设备及运行",
						"attachment": "https://bernouly.oss-cn-beijing.aliyuncs.com/train/%E5%9E%83%E5%9C%BE%E7%84%9A%E7%83%A7%E7%AC%AC%E4%B8%80%E6%9C%9F/%E8%AF%BE%E4%BB%B6/1.%E5%9E%83%E5%9C%BE%E7%84%9A%E7%83%A7%E5%8F%91%E7%94%B5%E6%9C%BA%E7%BB%84%E9%94%85%E7%82%89%E8%AE%BE%E5%A4%87%E5%8F%8A%E8%BF%90%E8%A1%8C.ppt",
						"attachment_name": "1.垃圾焚烧发电机组锅炉设备及运行",
					},
					{
						"name": "2.垃圾焚烧发电机组锅炉启停",
						"attachment": "https://bernouly.oss-cn-beijing.aliyuncs.com/train/%E5%9E%83%E5%9C%BE%E7%84%9A%E7%83%A7%E7%AC%AC%E4%B8%80%E6%9C%9F/%E8%AF%BE%E4%BB%B6/2.%E5%9E%83%E5%9C%BE%E7%84%9A%E7%83%A7%E5%8F%91%E7%94%B5%E6%9C%BA%E7%BB%84%E9%94%85%E7%82%89%E5%90%AF%E5%81%9C.ppt",
						"attachment_name": "2.垃圾焚烧发电机组锅炉启停",
					},
					{
						"name": "3.垃圾焚烧发电机组锅炉运行调整",
						"attachment": "https://bernouly.oss-cn-beijing.aliyuncs.com/train/%E5%9E%83%E5%9C%BE%E7%84%9A%E7%83%A7%E7%AC%AC%E4%B8%80%E6%9C%9F/%E8%AF%BE%E4%BB%B6/3.%E5%9E%83%E5%9C%BE%E7%84%9A%E7%83%A7%E5%8F%91%E7%94%B5%E6%9C%BA%E7%BB%84%E9%94%85%E7%82%89%E8%BF%90%E8%A1%8C%E8%B0%83%E6%95%B4.ppt",
						"attachment_name": "3.垃圾焚烧发电机组锅炉运行调整",
					},
					{
						"name": "4.垃圾焚烧发电机组汽轮机设备及系统",
						"attachment": "https://bernouly.oss-cn-beijing.aliyuncs.com/train/%E5%9E%83%E5%9C%BE%E7%84%9A%E7%83%A7%E7%AC%AC%E4%B8%80%E6%9C%9F/%E8%AF%BE%E4%BB%B6/4.%E5%9E%83%E5%9C%BE%E7%84%9A%E7%83%A7%E5%8F%91%E7%94%B5%E6%9C%BA%E7%BB%84%E6%B1%BD%E8%BD%AE%E6%9C%BA%E8%AE%BE%E5%A4%87%E5%8F%8A%E7%B3%BB%E7%BB%9F.ppt",
						"attachment_name": "4.垃圾焚烧发电机组汽轮机设备及系统",
					},
					{
						"name": "5.垃圾焚烧发电机组汽轮机运行",
						"attachment": "https://bernouly.oss-cn-beijing.aliyuncs.com/train/%E5%9E%83%E5%9C%BE%E7%84%9A%E7%83%A7%E7%AC%AC%E4%B8%80%E6%9C%9F/%E8%AF%BE%E4%BB%B6/5.%E5%9E%83%E5%9C%BE%E7%84%9A%E7%83%A7%E5%8F%91%E7%94%B5%E6%9C%BA%E7%BB%84%E6%B1%BD%E8%BD%AE%E6%9C%BA%E8%BF%90%E8%A1%8C.ppt",
						"attachment_name": "5.垃圾焚烧发电机组汽轮机运行",
					},
					{
						"name": "6.垃圾焚烧发电机组电气系统的主要设备和运行方式",
						"attachment": "https://bernouly.oss-cn-beijing.aliyuncs.com/train/%E5%9E%83%E5%9C%BE%E7%84%9A%E7%83%A7%E7%AC%AC%E4%B8%80%E6%9C%9F/%E8%AF%BE%E4%BB%B6/6.%E5%9E%83%E5%9C%BE%E7%84%9A%E7%83%A7%E5%8F%91%E7%94%B5%E6%9C%BA%E7%BB%84%E7%94%B5%E6%B0%94%E7%B3%BB%E7%BB%9F%E7%9A%84%E4%B8%BB%E8%A6%81%E8%AE%BE%E5%A4%87%E5%92%8C%E8%BF%90%E8%A1%8C%E6%96%B9%E5%BC%8F.pptx",
						"attachment_name": "6.垃圾焚烧发电机组电气系统的主要设备和运行方式",
					}
				]
			};
		},
		watch: {},
		created() {},
		mounted() {
			this.index = localStorage.getItem('index');
			//console.log(this.index);
			//在mounted()方法里监听mousewheel；
			// chrome and ie
			window.addEventListener('mousewheel', this.handleScroll, false)
			//// firefox
			window.addEventListener("DOMMouseScroll", this.handleScroll, false)
		},
		methods: {
			//师资培训-右侧视频列表下滑动
			arrowDown() {
				if (this.videoList.length - this.videoIndex > 4) {
					this.videoIndex = this.videoIndex + 1;
				}
			},
			//师资培训-右侧视频列表上滑动
			arrowUp() {
				if (this.videoIndex > 0) {
					this.videoIndex = this.videoIndex - 1;
				}
			},
			//师资培训-右侧视频列表点击播放事件
			change(n) {
				if (n != this.playIndex) {
					this.playIndex = n;
					this.videoFlag = true;
				}
			},
			//控制播放器播放，取消播放按钮样式
			videoPlay() {
				var video = document.getElementById('movie');
				video.play();
				this.videoFlag = false;
			},
			suojin() {
				if (this.jiantouFlag) {
					this.jiantouFlag = false;
				} else {
					this.jiantouFlag = true;
				}
			},
			fanhui() {
				this.$router.go(-1); //返回上一层
			},
			handleScroll(e) {
				//console.log("滑动了。。。")
				var direction = e.deltaY>0?'down':'up' //该语句可以用来判断滚轮是向上滑动还是向下
				if (document.getElementsByTagName("li").length == 1) { //此处决定无论一次滚轮滚动的距离是多少，此事件                                                              
					//都得等上次滚动结束，才会执行本次
					this.isShow = false
					setTimeout(() => {
						this.isShow = true
							++this.nowIndex
						if (this.nowIndex == 3) {
							this.nowIndex = 0
						}
					}, 10)
				}
			},
			wheel(){
				//console.log("vue滚动。。。")
			}

		}
	};
</script>

<style scoped>
	.certificate {
		position: relative;
	}

	.certificate-banner {
		width: 100%;
		height: 450px;
	}

	.train {
		width: 1200px;
		margin: 0 auto;
	}

	.w-video {
		background-color: #EDEDED;
		padding-bottom: 40px;
	}

	.video {
		/* border-radius:10px;
		-moz-box-shadow:0 0 8px #c2c2c2;
		-webkit-box-shadow:0 0 8px #c2c2c2;
		box-shadow:0 0 8px #c2c2c2; */
		padding: 50px;
		display: flex;
		justify-content: space-between;
		margin: auto auto;
		width: 946px;
		height: 532px;
	}

	.video-title, .course-title {
		/* padding-top: 30px; */
		margin-top: 60px;
		margin-bottom: 40px;
		text-align: center;
	}

	.video-title {
		margin-top: 0;
		margin-bottom: 10px;
	}

	.video-show {
		height: 92px;
		width: 92px;
		margin: -265px 0 0 427px;
		position: relative;
		z-index: 3;
		display: block;
	}

	.video-hidden {
		height: 92px;
		width: 92px;
		margin: -313.5px 0 0 427px;
		position: relative;
		z-index: 3;
		display: none;
	}

	.video-main {
		height: 532px;
		width: 946px;
		background-color: #999999;
	}

	.video-main-title {
		font-size: 24px;
		color: #FFFFFF;
		position: relative;
		z-index: 2;
		margin-top: -95px;
		margin-left: 20px;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
	}

	.bofang1:hover {
		cursor: pointer;
	}

	.video-mini {
		width: 225px;
		height: 532px;
		position: relative;
		margin-top: -412px;
		margin-left: 721px;
	}

	.video-mini ul {
		overflow: hidden;
		width: 225px;
		height: 532px;
	}

	.video-mini li {
		height: 126px;
		width: 225px;
		background: #999999;
		position: relative;
		cursor: pointer;
		margin-bottom: 10px;
	}

	.video-mini-title {
		display: inline-block;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
		max-width: 200px;
		letter-spacing: 1px;
		font-size: 14px;
		color: #FFFFFF;
		z-index: 3;
		position: absolute;
		margin-top: -22px;
		margin-left: 6px;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
	}

	.video-mini-title1 {
		display: inline-block;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
		max-width: 200px;
		letter-spacing: 1px;
		font-size: 14px;
		color: #f25b20;
		z-index: 3;
		position: absolute;
		margin-top: -22px;
		margin-left: 6px;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
	}

	.video-mini-img {
		display: inline-block;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
		max-width: 200px;
		letter-spacing: 1px;
		font-size: 14px;
		z-index: 3;
		position: absolute;
		margin-top: -76px;
		margin-left: 102px;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
	}

	.arrow-up {
		position: absolute;
		width: 225px;
		height: 25px;
		background: #FFFAFA;
		margin-top: -565px;
		text-align: center;
		cursor: pointer;
	}

	.arrow-down {
		width: 225px;
		height: 25px;
		background: #FFFAFA;
		position: absolute;
		margin-top: 6px;
		text-align: center;
		cursor: pointer;
	}

	.jiantou {
		position: relative;
		margin-left: 696px;
		margin-top: 80px;
	}

	.jiantou1 {
		position: relative;
		margin-left: 920px;
		margin-top: 80px;
	}

	.jiantou:hover {
		cursor: pointer;
	}

	.jiantou1:hover {
		cursor: pointer;
	}

	.revolve {
		-moz-transform: rotate(90deg);
		-webkit-transform: rotate(90deg);
		display: block;
		color: #2d73d9;
		font-size: 20px;
		width: 25px;
		margin: auto;
	}

	.title-page {
		display: flex;
		justify-content: space-between;
		width: auto;
		padding: 0px 20px 0px 75px;
		margin: 90px 0px 70px;
	}

	.title-page .box {
		width: 60px;
		height: 60px;
		text-align: center;
		line-height: 60px;
		margin-right: 2px;
		font-size: 16px;
		color: #333;
		background: #ddd;
	}

	.box:hover {
		cursor: pointer;
	}

	.title-page .flex {
		display: flex;
	}

	.title-page .active {
		color: #fff;
		background: #0055d3;
	}

	.title-page-active:active {
		background: #0055d3;
		color: #fff;
	}

	/* .down-list {
		min-height: 350px;
	} */

	.down-item {
		height: 80px;
		font-size: 16px;
		display: flex;
		justify-content: space-between;
		border-bottom: 1px #CCCCCC solid;
		line-height: 80px;
	}

	.icon {
		width: 26px;
		height: 26px;
	}

	.down-item-left {
		color: #333333;
		margin-left: 20px;
	}

	.down-item-left img {
		margin-top: -4px;
		vertical-align: middle;
		display: inline-block;
		margin-right: 20px;
	}

	.down-item-right {
		margin: auto 0;
		margin-right: 20px;
	}

	.down-item-right p {
		width: 136px;
		height: 30px;
		line-height: 30px;
		text-align: center;
		border: 2px solid #0055d3;
		border-radius: 30px;
		background: #fff;
		cursor: pointer;
	}

	.down-item-right p:hover {
		background: #0055d3;
		color: #fff;
	}

	.fanhui {
		display: inline-block;
		color: #606266;
		background: #fff;
		border: 1px solid #dcdfe6;
		padding: 10px 12px;
		margin-left: -107px;
		margin-top: -115px;
		position: absolute;
	}

	.fanhui:hover {
		color: #528CE0;
		cursor: pointer;
		border: 1px solid #DAE6FF;
	}
</style>
